export const highlight_colour = "#D1493B";
export const header_background_colour = "#EFE3D0";
export const footer_background_colour = "#383838";
export const footer_title_colour = "#D1BB93";
export const footer_secondary_colour = "#AFACA8";